<template>
  <model-table
    :collection="tipPools"
    :show-add="false"
    :show-edit="false"
    :columns="[
      { field: 'id' },
      { field: 'tipPoolType', component: 'model' },
      { name: 'state', field: tipPool => $_.startCase(tipPool.state), component: 'chip' },
      { field: 'openedAt', component: 'date-time' },
      { field: 'closedAt', component: 'date-time' },
      { field: 'distributedAt', component: 'date-time' },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
  >
    <tip-pool-form />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import TipPoolForm from 'src/modules/admin/tip/TipPoolForm'

export default {
  name: 'TipPoolTable',
  components: {
    ModelTable,
    TipPoolForm
  },
  models: {
    tipPools: {
      tipPoolType: {
        fields: ['id', 'name']
      },
      variables () {
        return {
          noCount: true
        }
      }
    }
  }
}
</script>
